<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
    <template #freight="{ visible, params, close }">
      <FrightAppend :rows="params" :close="close" v-if="visible" />
    </template>
  </cTable>
</template>

<script>
import {
  getDetails,
  addFreight,
  getFreight,
  hangBill,
  uploadBillFlie,
  exportUpload,
  getExtFiles,
  addExtFiles,
  deleteFile,
  deleteDetails,
} from "@/api/finance/bill";
import { getExpense } from "@/api/finance/expense";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";
import FrightAppend from "./fright_append.vue";

export default {
  components: {
    cTable,
    FrightAppend,
  },
  props: {
    row: {
      type: Object,
    },
  },
  data() {
    return {
      config: {
        slot: "div",
        rows: this.row,
      },
      methods: {
        list: (p) => {
          p.id = this.config.rows.id;
          return getDetails(p);
        },
        getExpense,
        getExtFiles,
        hangBill,
        exportUpload,
        uploadBillFlie,
        deleteDetails,
        deleteFile,
        addExtFiles,
        addFreight,
        getFreight,
        getCountry,
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          this.totalAmount.push([
            {
              text: this.$t("total"),
              replace_currency: "CNY",
              total_amount: data.total_cny,
            },
            {
              text: this.$t("total"),
              replace_currency: "USD",
              total_amount: data.total_usd,
            },
          ]);
        },
      },
      totalAmount: [],
      modals: {
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map((item) => item.id);
              data.id = this.$page.config.rows.id;
              this.$page.handleRequestMethods("hangBill", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 80,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        uploadFiles: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.id = this.$page.config.rows.id;
              this.$page
                .handleRequestMethods("addExtFiles", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            modalContentBind: {
              style: {
                height: "600px",
              },
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ files: 23 }, { deductible_fee: 23 }, { other_charges: 23 }],
          fields: [
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx,.xls",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file);
                  formData.append("batchNo", new Date().getTime());
                  uploadBillFlie(this.config.rows.id, formData).then((res) => {
                    this.$Message[res.data.status ? "success" : "error"]({
                      background: true,
                      content: res.data.msg,
                    });
                    if (res.data.status) {
                      this.$refs["table"]
                        .getModal("uploadFiles")
                        .list.push(res.data.payload);
                    }
                  });
                  return false;
                },
              },
            },
            {
              name: () => this.$t("deductExpenses"),
              key: "deductible_fee",
              component: "InputNumber",
              bind: {
                step: 0.01,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("receivable") + this.$t("otherCost"),
              key: "other_charges",
              component: "InputNumber",
              bind: {
                step: 0.01,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                name: () => this.$t("fileName"),
                key: "file_name",
                align: "left",
                minWidth: 170,
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 80,
                list: [
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    bind: {
                      icon: "md-trash",
                    },
                  },
                ],
                methods: {
                  delete({ row }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods("deleteFile", row.id).then(
                          (res) => {
                            this.$Message["success"]({
                              background: true,
                              content: res.msg,
                            });
                            this.handleRequestMethods(
                              "getExtFiles",
                              this.config.rows.id
                            ).then((res) => {
                              this.getModal("uploadFiles").open(
                                res,
                                function () {
                                  this.list = res.payload.files;
                                }
                              );
                            });
                          }
                        );
                      },
                    });
                  },
                },
              },
            ],
          },
        },
        freightAppend: {
          contentSlot: "freight",
          config: {
            modalBind: {
              width: 800,
              draggable: true,
              sticky: true,
            },
          },
          footer: {
            show: () => false,
          },
        },
      },
      footer: {
        show: () => true,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    parseFloat(item.total_amount)
                  ),
                ]
              );
            })
          );
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            component: "Select",
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
              // id: 132
            },
            {
              name: this.$t("updateFile") + this.$t("Appendix"),
              type: "handUpload",
              fnName: "handUpload",
              bind: {
                icon: "ios-cloud-upload-outline",
                type: "warning",
              },
              // id: 456
            },
            {
              name: this.$t("hang"),
              type: "hang",
              fnName: "hang",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.config.rows.status != "WAIT_CONFIRM"
                );
              },
              // id: 661
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.config.rows.status != "WAIT_CONFIRM"
                );
              },
            },
          ],
          methods: {
            export() {
              this.handleRequestMethods(
                "exportUpload",
                this.config.rows.id
              ).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                window.open(this.$globalUrl + res.payload.path);
              });
            },
            handUpload() {
              this.handleRequestMethods(
                "getExtFiles",
                this.config.rows.id
              ).then((res) => {
                this.getModal("uploadFiles").open(res, function () {
                  this.list = res.payload.files;
                  this.setTitle(this.$t("updateFile") + this.$t("files"));
                });
              });
            },
            hang() {
              this.getModal("hang").open({}, function () {
                this.setTitle(this.$t("hang"));
              });
            },
            delete() {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    id: this.config.rows.id,
                    ids: this.selectAll.map((item) => {
                      return item.id;
                    }),
                  };
                  this.handleRequestMethods("deleteDetails", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("inbound_time"),
          key: "inbound_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          minWidth: 170,
        },
        {
          name: () => this.$t("clientName"),
          key: "clientInfo",
          minWidth: 100,
          methods: {
            render({ value }) {
              return value && value.account;
            },
          },
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130,
        },
        {
          name: () => this.$t("countryName"),
          key: "to_country",
          minWidth: 100,
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_volume"),
          key: "charge_volume",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_params"),
          key: "charge_params",
          minWidth: 100,
        },
        {
          name: () => this.$t("values"),
          key: "values",
          minWidth: 100,
        },
        {
          name: () => this.$t("cod_type"),
          key: "cod_type",
          minWidth: 95,
        },
        {
          name: () => this.$t("replace_currency"),
          key: "replace_currency",
          minWidth: 95,
        },
        {
          name: () => this.$t("cod_amount"),
          key: "cod_amount",
          minWidth: 100,
        },
        {
          name: () => "Usd To Cny",
          key: "usd_to_cny",
          minWidth: 115,
        },
        {
          name: () => "USD",
          minWidth: 120,
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "freight_fees_usd",
              minWidth: 120,
            },
            {
              name: () => this.$t("total_tax"),
              key: "total_tax_usd",
              minWidth: 120,
            },
            {
              name: () => this.$t("vat_fee"),
              key: "vat_fee_usd",
              minWidth: 130,
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tax_fee_usd",
              minWidth: 120,
            },
            {
              name: () => this.$t("document_fee"),
              key: "document_fee_usd",
              minWidth: 130,
            },
            {
              name: () => this.$t("freight_append"),
              key: "other_fee_usd",
              minWidth: 120,
              component: this.$hasPermission(133) ? "Button" : "span",
              bind: {
                type: "primary",
                size: "small",
              },
              methods: {
                click({ row }) {
                  if (this.$hasPermission(133)) {
                    let data = {
                      id: this.config.rows.id,
                      fid: row.id,
                      status: this.config.rows.status,
                    };

                    this.$page
                      .getModal("freightAppend")
                      .open(data, function () {
                        this.setTitle(this.$t("freight_append"));
                      });
                  }
                },
              },
            },
          ],
        },
        {
          name: () => "CNY",
          minWidth: 120,
          children: [
            {
              name: () => this.$t("freight_fees"),
              key: "freight_fees_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("total_tax"),
              key: "total_tax_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("vat_fee"),
              key: "vat_fee_cny",
              minWidth: 130,
            },
            {
              name: () => this.$t("tax_fee"),
              key: "tax_fee_cny",
              minWidth: 120,
            },
            {
              name: () => this.$t("document_fee"),
              key: "document_fee_cny",
              minWidth: 130,
            },
            {
              name: () => this.$t("freight_append"),
              key: "other_fee_cny",
              minWidth: 120,
              component: this.$hasPermission(133) ? "Button" : "span",
              bind: {
                type: "primary",
                size: "small",
              },
              methods: {
                click({ row }) {
                  if (this.$hasPermission(133)) {
                    let data = {
                      id: this.config.rows.id,
                      fid: row.id,
                      status: this.config.rows.status,
                    };

                    this.$page
                      .getModal("freightAppend")
                      .open(data, function () {
                        this.setTitle(this.$t("freight_append"));
                      });
                  }
                },
              },
            },
          ],
        },
      ],
    };
  },
  async mounted() {
    let data = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "to_country") item.options = data;
    });
  },
};
</script>
